'use strict';

/**
 * Sampling Service
 */
module.service('SamplingService', ['SampleService', 'Restangular', '$q', function(SampleService, Restangular, $q) {

    /*
     * ------------------------------------------------------------------------------
     * SERVICE FUNCTIONS
     * -------------------------------------------------------------------------------
     */
	
	var ss = Object.create(SampleService);
	
    ss.getSamplingList = function(id) {
        var deferred = $q.defer();
        var answer = new restResponse();
        Restangular.one('plansampling',id).customGET('sampling').then(function(response) {
            answer.handleSuccessfullResponse(response, response.data);
            deferred.resolve(answer);
        }, function(response) {
            answer.handleErrorResponse(response, response.data);
            deferred.reject(answer);
        });
        return deferred.promise;
    };
    
    ss.getSamplingHome = function(idPlan, idSampling) {
        var deferred = $q.defer();
        var answer = new restResponse();
        Restangular.one('plansamplinghome',idPlan).one('sampling',idSampling).get().then(function(response) {
            answer.handleSuccessfullResponse(response, response.data);
            deferred.resolve(answer);
        }, function(response) {
            answer.handleErrorResponse(response, response.data);
            deferred.reject(answer);
        });
        return deferred.promise;
    };
    
    ss.getSamplingHomeList = function(id, filters) {
        var deferred = $q.defer();
        var answer = new restResponse();
        Restangular.one('plansamplinghome',id).customGET('sampling', filters).then(function(response) {
            answer.handleSuccessfullResponse(response, response.data);
            deferred.resolve(answer);
        }, function(response) {
            answer.handleErrorResponse(response, response.data);
            deferred.reject(answer);
        });
        return deferred.promise;
    };
    
    ss.getSamplingHomeListForClientUser = function(id, filters) {
        var deferred = $q.defer();
        var answer = new restResponse();
        Restangular.one('plansamplinghome/forclientuser',id).customGET('sampling', filters).then(function(response) {
            answer.handleSuccessfullResponse(response, response.data);
            deferred.resolve(answer);
        }, function(response) {
            answer.handleErrorResponse(response, response.data);
            deferred.reject(answer);
        });
        return deferred.promise;
    };
    
    ss.addSampling = function(idPlan, createModel) {
        var deferred = $q.defer();
        var answer = new restResponse();
        Restangular.one('plansampling',idPlan).customPOST(createModel,'sampling').then(function(response) {
            answer.handleSuccessfullResponse(response, response.data);
            deferred.resolve(answer);
        }, function(response) {
            answer.handleErrorResponse(response, response.data);
            deferred.reject(answer);
        });
        return deferred.promise;
    };
    
    ss.updateSampling = function(idPlan, idSampling, updateModel) {
        var deferred = $q.defer();
        var answer = new restResponse();
        Restangular.one('plansampling',idPlan).one('sampling',idSampling).customPUT(updateModel).then(function(response) {
            answer.handleSuccessfullResponse(response, response.data);
            deferred.resolve(answer);
        }, function(response) {
            answer.handleErrorResponse(response, response.data);
            deferred.reject(answer);
        });
        return deferred.promise;
    };
    
    ss.removeSampling = function(idPlan, idSampling){
    	var deferred = $q.defer();
        var answer = new restResponse();
        Restangular.one('plansampling',idPlan).one('sampling',idSampling).remove().then(function(response) {
            answer.handleSuccessfullResponse(response, response.data);
            deferred.resolve(answer);
        }, function(response) {
            answer.handleErrorResponse(response, response.data);
            deferred.reject(answer);
        });
        return deferred.promise;
    };
    
    ss.getSamplingOne = function(idPlan, idSampling) {
        var deferred = $q.defer();
        var answer = new restResponse();
        Restangular.one('plansampling',idPlan).one('sampling',idSampling).get().then(function(response) {
            answer.handleSuccessfullResponse(response, response.data);
            deferred.resolve(answer);
        }, function(response) {
            answer.handleErrorResponse(response, response.data);
            deferred.reject(answer);
        });
        return deferred.promise;
    };
    
    ss.getSamplingBasicInfo = function(idPlan, idSampling) {
        var deferred = $q.defer();
        var answer = new restResponse();
        Restangular.one('plansamplingsimple',idPlan).one('sampling',idSampling).get().then(function(response) {
            answer.handleSuccessfullResponse(response, response.data);
            deferred.resolve(answer);
        }, function(response) {
            answer.handleErrorResponse(response, response.data);
            deferred.reject(answer);
        });
        return deferred.promise;
    };
    
    ss.getSamplingList = function(idPlan, idSampling) {
        var deferred = $q.defer();
        var answer = new restResponse();
        Restangular.one('plansampling',idPlan).one('sampling',idSampling).get().then(function(response) {
            answer.handleSuccessfullResponse(response, response.data);
            deferred.resolve(answer);
        }, function(response) {
            answer.handleErrorResponse(response, response.data);
            deferred.reject(answer);
        });
        return deferred.promise;
    };
    
    ss.getSamplingAnalysisList = function(idPlan, idSampling) {
        var deferred = $q.defer();
        var answer = new restResponse();
        Restangular.one('plansampling',idPlan).one('sampling',idSampling).customGET('analysis').then(function(response) {
            answer.handleSuccessfullResponse(response, response.data);
            deferred.resolve(answer);
        }, function(response) {
            answer.handleErrorResponse(response, response.data);
            deferred.reject(answer);
        });
        return deferred.promise;
    };
    
    ss.addSamplingAnalysis = function(idPlan, idSampling, createModel) {
        var deferred = $q.defer();
        var answer = new restResponse();
        Restangular.one('plansampling',idPlan).one('sampling',idSampling).customPOST(createModel, 'analysis').then(function(response) {
            answer.handleSuccessfullResponse(response, response.data);
            deferred.resolve(answer);
        }, function(response) {
            answer.handleErrorResponse(response, response.data);
            deferred.reject(answer);
        });
        return deferred.promise;
    };

    ss.addSamplingAnalysisMulti = function(idPlan, idSampling, createModel) {
        var deferred = $q.defer();
        var answer = new restResponse();
        Restangular.one('plansampling',idPlan).one('sampling',idSampling).customPOST(createModel, 'analysisMulti').then(function(response) {
            answer.handleSuccessfullResponse(response, response.data);
            deferred.resolve(answer);
        }, function(response) {
            answer.handleErrorResponse(response, response.data);
            deferred.reject(answer);
        });
        return deferred.promise;
    };

    
    ss.updateSamplingAnalysis = function(idPlan, idSampling, idSamplingAnalysis, updateModel) {
        var deferred = $q.defer();
        var answer = new restResponse();
        Restangular.one('plansampling',idPlan).one('sampling',idSampling).one('analysis',idSamplingAnalysis).customPUT(updateModel).then(function(response) {
            answer.handleSuccessfullResponse(response, response.data);
            deferred.resolve(answer);
        }, function(response) {
            answer.handleErrorResponse(response, response.data);
            deferred.reject(answer);
        });
        return deferred.promise;
    };
    
    ss.removeSamplingAnalysis = function(idPlan, idSampling, idSamplingAnalysis) {
        var deferred = $q.defer();
        var answer = new restResponse();
        Restangular.one('plansampling',idPlan).one('sampling',idSampling).one('analysis',idSamplingAnalysis).remove().then(function(response) {
            answer.handleSuccessfullResponse(response, response.data);
            deferred.resolve(answer);
        }, function(response) {
            answer.handleErrorResponse(response, response.data);
            deferred.reject(answer);
        });
        return deferred.promise;
    };
    
    ss.removeAllSamplingAnalysis = function(idPlan, idSampling) {
        var deferred = $q.defer();
        var answer = new restResponse();
        Restangular.one('plansampling',idPlan).one('sampling',idSampling).all('allAnalysis').remove().then(function(response) {
            answer.handleSuccessfullResponse(response, response.data);
            deferred.resolve(answer);
        }, function(response) {
            answer.handleErrorResponse(response, response.data);
            deferred.reject(answer);
        });
        return deferred.promise;
    };
        
    return ss;
} ]);

